import { render, staticRenderFns } from "./ClientsImport.vue?vue&type=template&id=74362deb&"
import script from "./ClientsImport.vue?vue&type=script&lang=js&"
export * from "./ClientsImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports